import { Outlet, useNavigate, useLocation } from 'react-router';
import { useTelegram } from '../hooks/useTelegram';
import { useMemo } from 'react';

export function Layout(): React.JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useTelegram();

  // Определение роли (в MVP по хардкоду ID)
  const isSuperAdmin = user?.id === 1088744046;

  // Разные меню для разных ролей
  const navItems = useMemo(() => {
    if (isSuperAdmin) {
      return [
        { path: '/', label: 'Платформа', icon: '📊' },
        { path: '/owners', label: 'Владельцы', icon: '👥' },
        { path: '/logs', label: 'Логи', icon: '📜' },
        { path: '/billing', label: 'Тарифы', icon: '💎' },
      ];
    }
    return [
      { path: '/', label: 'Главная', icon: '📊' },
      { path: '/bookings', label: 'Записи', icon: '📅' },
      { path: '/settings', label: 'Настройки', icon: '⚙️' },
      { path: '/staff', label: 'Команда', icon: '👥' },
    ];
  }, [isSuperAdmin]);

  return (
    <div className="container">
      <header className="header-status">
        <div className="status-item">
          <span className="status-label">Профиль</span>
          <span className="status-value">{isSuperAdmin ? 'SUPER ADMIN 🛡️' : 'OWNER 🏢'}</span>
        </div>
        <div className="status-item" style={{ textAlign: 'right' }}>
          <span className="status-label">Система</span>
          <span className="status-value" style={{ color: '#34C759' }}>Online 🟢</span>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <nav className="tab-bar">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`tab-item ${isActive ? 'active' : ''}`}
            >
              <span className="tab-icon">{item.icon}</span>
              <span className="tab-label">{item.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
